import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import getById from 'utils/DOM/getById'
import innerHTML from 'utils/DOM/innerHTML'

function renderCoverageMenu(data) {
  if (data) {
    const template = Templater(getById('template-coverage-menu').innerText)

    innerHTML(getById('coverage__menu--nav'), data.plan.map(template).join(''))

    return true
  }

  return false
}

export default renderCoverageMenu
